import { useState, type FormEvent } from "react";
import { Link } from "react-router-dom";
import { requestAdminMagicLink } from "../../lib/api";
import { InlineSpinner } from "../../components/Loading";
import { AdminBadge } from "../../components/AdminHeader";
import {
  ArrowRightIcon,
  Eyebrow,
  HeadingItalic,
  Wordmark,
} from "../../components/design";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    setError(null);
    setBusy(true);
    try {
      await requestAdminMagicLink(email.trim());
      setSubmitted(true);
    } catch (err: any) {
      setError(err?.message || "Etwas ist schiefgelaufen.");
    } finally {
      setBusy(false);
    }
  }

  return (
    <div
      className="paper-bg"
      style={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <header
        style={{
          background: "var(--paper-100)",
          borderBottom: "1px solid rgba(43,26,15,0.10)",
        }}
      >
        <div
          style={{
            maxWidth: 960,
            margin: "0 auto",
            padding: "18px 22px",
            display: "flex",
            alignItems: "center",
            gap: 10,
          }}
        >
          <Link
            to="/"
            aria-label="Vitanara"
            style={{ textDecoration: "none" }}
          >
            <Wordmark />
          </Link>
          <AdminBadge />
        </div>
      </header>

      <main
        style={{
          flex: 1,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: "32px 22px",
        }}
      >
        <div style={{ width: "100%", maxWidth: 420 }}>
          <Eyebrow>Admin-Bereich</Eyebrow>
          <HeadingItalic size={32}>
            Admin-<em>Anmeldung</em>.
          </HeadingItalic>
          <p
            style={{
              fontFamily: "var(--f-body)",
              fontSize: 16,
              lineHeight: 1.5,
              color: "var(--ink-soft)",
              margin: "0 0 24px",
            }}
          >
            Geben Sie Ihre freigeschaltete Admin-E-Mail-Adresse ein. Wir
            senden Ihnen einen einmaligen Login-Link, der 15 Minuten gültig
            ist.
          </p>

          {submitted ? (
            <div
              style={{
                background: "rgba(95,107,79,0.12)",
                border: "1px solid rgba(95,107,79,0.30)",
                borderLeft: "3px solid var(--sage)",
                borderRadius: 4,
                padding: "14px 16px",
                color: "var(--ink-soft)",
              }}
            >
              <p
                style={{
                  fontFamily: "var(--f-display)",
                  fontWeight: 500,
                  margin: "0 0 6px",
                  color: "var(--ink)",
                }}
              >
                Link unterwegs ✓
              </p>
              <p
                style={{
                  fontFamily: "var(--f-body)",
                  fontSize: 14,
                  margin: 0,
                }}
              >
                Falls <strong>{email}</strong> als Admin freigeschaltet ist,
                liegt jetzt eine E-Mail in Ihrem Postfach.
              </p>
            </div>
          ) : (
            <form
              onSubmit={onSubmit}
              style={{ display: "flex", flexDirection: "column", gap: 14 }}
            >
              <div>
                <label
                  htmlFor="email"
                  className="t-caps"
                  style={{ display: "block", marginBottom: 6 }}
                >
                  Admin-E-Mail
                </label>
                <input
                  id="email"
                  type="email"
                  autoComplete="email"
                  required
                  className="input"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="ihre.e-mail@firma.de"
                />
              </div>
              {error && (
                <p
                  role="alert"
                  style={{
                    fontFamily: "var(--f-body)",
                    fontStyle: "italic",
                    fontSize: 13,
                    color: "var(--oxblood)",
                    margin: 0,
                  }}
                >
                  {error}
                </p>
              )}
              <button
                type="submit"
                disabled={busy || !email}
                className="btn-primary"
                style={{ width: "100%", boxSizing: "border-box" }}
              >
                {busy ? <InlineSpinner /> : "Admin-Link senden"}
                {!busy && <ArrowRightIcon />}
              </button>
            </form>
          )}

          <p
            style={{
              marginTop: 18,
              textAlign: "center",
              fontFamily: "var(--f-ui)",
              fontSize: 12,
              color: "var(--ink-faint)",
            }}
          >
            <Link to="/login" style={{ color: "inherit" }}>
              Kunden-Login
            </Link>
            {" · "}
            <Link to="/" style={{ color: "inherit" }}>
              Zurück
            </Link>
          </p>
        </div>
      </main>
    </div>
  );
}
